import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UntypedFormBuilder } from '@angular/forms';

@Component({
  standalone: false,
    selector: 'app-order-remark-dialog',
    templateUrl: './order-remark-dialog.component.html',
    styleUrls: ['./order-remark-dialog.component.scss'],
})
export class OrderRemarkDialogComponent implements AfterViewInit {
    @ViewChild('remarkInput') remarkInput!: ElementRef<HTMLInputElement>;

    remarkForm = this.formBuilder.group({
        orderRemark: '',
        orderAudioOnly: false,
    });

    constructor(private ref: DynamicDialogRef, private formBuilder: UntypedFormBuilder, public config: DynamicDialogConfig) {}

    ngAfterViewInit(): void {
        setTimeout(() => this.remarkInput?.nativeElement?.focus());
    }

    closeDialog() {
        this.ref.close();
    }

    orderWithRemark() {
        this.ref.close(this.remarkForm.value);
    }
}
